import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import reports from '../../../pages/Features/ProjectHighlight/ProjectHighlight.module.css';
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import { useCommon } from "../../Common/useCommon";
import { useNavigate } from "react-router-dom";
import { dateConvert } from "../../../utils/Helper";
import { DateTime } from "luxon";


export const useProjHighlight = () => {
    const { getValuePermission } = useCommon();
    const [loader, setLoader] = useState(true);
    const { showInfo } = useContext(ToastContext);
    const gridRef = useRef();
    const [distinctProjectCount, setDistinctProjectCount] = useState({
        ProjectCount: 0,
    });
    const [rowData, setRowData] = useState([]);
    const navigate = useNavigate();
    const [addProjectPopup, setAddProjectPopup] = useState(false);
    const [selectProjectId, setSelectProjectId] = useState(null)
    const tagRef = useRef(null);
    const [filterOpts, setFilterOpts] = useState({ client: [], lead: [], status: [] })
    const [filterValues, setFilterValues] = useState({ date: null, client: null, lead: [], status: [] });
    const [hoveredRange, setHoveredRange] = useState([]);
    const [isChange, setIsChange] = useState(false);
    const [isFilterChange, setIsFilterChange] = useState(false);
    const [historyPopup, setHistoryPopup] = useState(false);
    const [historyLoader, setHistoryLoader] = useState(false);
    const [historyRowData, setHistoryRowData] = useState([]);
    const [historyColDef] = useState([
        {
            field: "user_display_name",
            headerName: "Employee Name",
            flex: 0.7
        },
        {
            field: "project_role_name",
            headerName: "Project Role",
            flex: 1
        },
        {
            field: "alloted_date",
            headerName: "Alloted Date",
            flex: 0.5,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value ? DateTime.fromISO(params?.value).toFormat('dd MMM yyyy') : "-"}</div>
                )
            }
        },
        {
            field: "expired_date",
            headerName: "Revoke Date",
            flex: 0.5,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value ? DateTime.fromISO(params?.value).toFormat('dd MMM yyyy') : "-"}</div>
                )
            }
        },
        {
            field: "is_billable",
            headerName: "Is Billable",
            flex: 0.5,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && <FontAwesomeIcon icon="fa-solid fa-circle-check" className="text-success" />}</div>
                )
            }
        },
    ])
    const [columnDefs] = useState([
        {
            headerName: "Action",
            suppressHeaderMenuButton: true,
            width: 60,
            pinned: 'left',
            hide: getValuePermission("project_highlight_edit_project_column"),
            cellRenderer: function (params) {
                return (
                    <div className="text-center" >
                        {
                            params?.data?.project_id && < FontAwesomeIcon icon="fa-solid fa-edit" onClick={() => { setSelectProjectId(params?.data); setAddProjectPopup(true) }} />
                        }
                    </div>
                );
            },

        },
        {

            field: 'project_name',
            headerName: 'Project Name',
            width: 220,
            pinned: 'left',
            cellRenderer: function (params) {
                return (
                    <div style={{ display: 'flex' }}>
                        <span className={reports['link']}> {params.value}</span>
                    </div>
                )
            },
            comparator: (valueA, valueB) => {
                if (!valueA) valueA = '';
                if (!valueB) valueB = '';
                return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
            },
        },
        {
            field: 'project_key',
            headerName: 'Project Key',
            width: 100,
            cellRenderer: function (params) {
                const project_key = params.data.project_key || '-'
                return (
                    <div className="d-flex gap-2 align-items-center" title={project_key}>
                        <span>{project_key}</span>
                    </div>
                )

            }

        },
        {
            field: 'client_names',
            headerName: 'Project Client',
            width: 170,
            cellRenderer: function (params) {
                const client_names = params.data.client_names || '-';
                return (
                    <div className="d-flex gap-2 align-items-center" title={client_names}>
                        <span>{client_names}</span>
                    </div>
                );
            }
        },
        {
            field: 'project_leads',
            headerName: 'Project Leads',
            width: 170,
            cellRenderer: function (params) {
                const leads = params.data?.leads || [];
                return (
                    <div className=" d-flex gap-2 align-items-center" title={params?.value}>
                        {leads.map((lead, index) => (
                            <div key={index} className="d-flex align-items-center">
                                {lead.image && (
                                    <img src={lead.image} className={reports["image"]} />
                                )}
                                <span>{lead.name || '-'}</span>
                            </div>
                        ))}
                    </div>
                );
            },
        },
        {
            field: 'developer_team_count', headerName: "Project Team", width: 80, cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                const devOps = params.data.developer_team_count
                return (
                    <div>
                        <span className="custom-target-icon" style={{ fontSize: '13px', fontWeight: "600", cursor: 'pointer', color: '#0065FF' }} height="50px">
                            {devOps !== 0 && devOps !== null ? devOps : "-"}
                        </span>
                    </div>
                );
            },
        },
        {
            field: 'external_support', headerName: "Ext. Team", width: 70, cellStyle: { textAlign: "center" },
            cellRenderer: function (params) {
                const External = params.data.external_support
                return (
                    <div>
                        <span className="custom-target-icon" style={{ fontSize: '13px', fontWeight: "600", cursor: 'pointer', color: '#0065FF' }} height="50px">
                            {External !== 0 && External !== null ? External : "-"}
                        </span>
                    </div>
                );
            },
        },
        {
            field: 'project_status_name', headerName: 'Status', width: 80,
            cellRenderer: function (params) {
                const status = params.data.project_status_name
                if (status) {
                    if (status === "Active") {
                        return (
                            <span className='ideal-status'><FontAwesomeIcon icon="fa-solid fa-clock" className='fa-solid fa-check' /> {status}</span>
                        )
                    } else if (status === "Hold") {
                        return (
                            <span className='hold-status'><FontAwesomeIcon icon="fa-solid fa-pause" className='fa-solid fa-check' /> {status}</span>
                        )
                    } else {
                        return (
                            <span className='ideal-status'><FontAwesomeIcon icon="fa-solid fa-clock" className='fa-solid fa-check' /> {status}</span>
                        )
                    }
                }
            }
        },
        {
            field: 'project_start_date', headerName: 'Start Date', width: 90, cellStyle: { textAlign: "center" },
            valueFormatter: params => params.value ? moment(params.value).format('DD MMM YYYY') : '-',
        },
        {
            headerName: "Bid Information",
            headerClass: "project-highlight-header-group",
            children: [
                {
                    field: "backlog",
                    headerName: "Backlog",
                    width: 70,
                    cellStyle: { textAlign: "center" },

                },
                {
                    field: "in_progress",
                    headerName: "In Progress",
                    width: 75,
                    cellStyle: { textAlign: "center" },
                },
                {
                    field: "done",
                    headerName: "Done",
                    width: 70,
                    cellStyle: { textAlign: "center" },
                },
            ]
        },
        {
            field: "working_hours",
            headerName: "Working Hours",
            width: 70,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" }
        },
        {
            field: "working_days",
            headerName: "Working Days",
            width: 70,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" }
        },
        {
            field: "project_history_count",
            headerName: "Project History",
            width: 70,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <>
                        {params?.value ?
                            <div className={`c-pointer ${reports['link']}`} onClick={() => { getProjectHistory(params?.data) }}>{params?.value}</div>
                            : "-"
                        }
                    </>
                )
            }
        },
        {
            field: "project_timesheet_details",
            headerName: "TimeSheet",
            width: 70,
            headerClass: "header-wrap",
            cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
            cellRenderer: (params) => {
                const { project_id } = params.data;
                return (
                    <>
                        <button style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'black', gap: '5px' }} onClick={() => handleTimesheetClick(project_id)}>
                            <FontAwesomeIcon icon="fa-solid fa-calendar-check" style={{ color: 'black', }} />
                        </button>

                    </>

                )
            }
        },
    ])

    useEffect(() => {
        callautopopulate("project_category", "projects", "project_tags", "users", "project_leads").then(res => {
            setFilterOpts((prev) => ({ ...prev, lead: res?.project_leads, client: _.sortBy(res?.project_category, "client_name") }))
        });
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (filterValues?.apiCall && ((!hoveredRange?.[0] && !hoveredRange?.[1]) || (hoveredRange?.[0] && hoveredRange?.[1]) || isFilterChange)
        ) {
            getProjectHighlights();
        }
    }, [hoveredRange, isFilterChange,filterValues?.apiCall]);

    useEffect(() => {
        const uniqueProjects = new Set(rowData?.map(item => item.project_name));
        setDistinctProjectCount({
            ProjectCount: uniqueProjects.size,
        });
        // eslint-disable-next-line
    }, [rowData]);


    const processData = (data) => {
        return data.map(item => {
            const leadsArray = item.project_leads
                ? item.project_leads.split(',').map(name => name.trim())
                : [];
            const imagesArray = item.project_lead_image_url
                ? item.project_lead_image_url.split(',').map(url => url.trim())
                : [];
            const leads = leadsArray.map((name, index) => ({
                name,
                image: imagesArray[index] || null,
            }));
            return { ...item, leads };
        });
    };

    // get project highlights data
    const getProjectHighlights = async () => {
        const payload = {
            client_id: filterValues?.project_category?.client_id || 0,
            project_lead_accountId: _.pluck(filterValues?.project_leads, "user_code")?.toString(),
            from_date: dateConvert(hoveredRange?.[0], "iso-string"),
            to_date: dateConvert(hoveredRange?.[1], "iso-string")
        }

        try {
            setLoader(true);
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTLIST'), payload)
            if (res?.body?.data) {
                const data = _.sortBy(res?.body?.data.project_List, "project_name");
                const processedData = processData(data);
                setRowData(processedData);
                setLoader(false);
            }
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    };


    // navigate to project details or report
    const onCellClicked = (event) => {
        if (event?.colDef?.headerName !== 'Tools') {
            let obj = {}
            if (event?.colDef?.headerName === "Project Team" || event?.colDef?.headerName === "DevOps" || event?.colDef?.headerName === "Ext. Team") {
                if (event?.data?.developer_team_count === 0 && event?.data?.external_support === 0) {
                    showInfo("info", 'No Resource Available');
                } else {
                    obj = {
                        project_id: event?.data?.project_id,
                        project_name: `${event?.data?.project_name} (${(event?.colDef?.headerName)})`,
                        key: event?.colDef?.headerName === "Project Team" ? "d" : event?.colDef?.headerName === "Ext. Team" ? "e" : "d",
                    }
                    navigate("/project-details", { state: obj })
                }
            } else if (event?.colDef?.headerName === "Project Name") {
                if (event.data.project_name.includes("Total Projects")) {
                    return;
                }
                obj = {
                    project_id: event?.data?.project_id,
                    project_name: `${event?.data?.project_name} (${(event?.colDef.headerName)})`,
                }
                navigate("/project-report", { state: obj })
            }
        }
    }

    const handleTimesheetClick = (project_id) => {
        navigate('/project-timesheet-details', { state: { project_id } });
    };


    const onFilterTextBoxChanged = useCallback(() => {
        gridRef?.current?.api?.setGridOption(
            'quickFilterText',
            document.getElementById('filter-text-box').value
        );
    }, []);

    // set total row at bottom
    const pinnedBottomRowData = useMemo(() => [
        {
            project_name: `Total Projects: ${distinctProjectCount.ProjectCount}`
        }
    ], [distinctProjectCount]);

    const getProjectHistory = async (rowdata) => {
        try {
            setHistoryLoader(true);
            setHistoryRowData([]);
            setHistoryPopup(true);
            const payload = {
                product_code: rowdata?.product_code,
                project_code: rowdata?.project_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTMEMBERSALLOCATIONHISTORY"), payload);
            if (res) {
                setHistoryRowData(res?.body?.data?.poject_members_allocation_details);
                setHistoryLoader(false);
            }
        } catch (error) {
            console.error("error: ", error);
            setHistoryLoader(false);
        }
    }

    return useMemo(() => ({
        tagRef, onFilterTextBoxChanged, getProjectHighlights, columnDefs, rowData, loader, onCellClicked, gridRef, pinnedBottomRowData, addProjectPopup, setAddProjectPopup, setSelectProjectId, selectProjectId, filterOpts, filterValues, setFilterValues, hoveredRange, setHoveredRange, isChange, setIsChange, isFilterChange, setIsFilterChange, historyPopup, setHistoryPopup, historyRowData, historyColDef, historyLoader
    }), [tagRef, onFilterTextBoxChanged, getProjectHighlights, columnDefs, rowData, loader, onCellClicked, gridRef, pinnedBottomRowData, addProjectPopup, setAddProjectPopup, setSelectProjectId, selectProjectId, filterOpts, filterValues, setFilterValues, hoveredRange, setHoveredRange, isChange, setIsChange, isFilterChange, setIsFilterChange, historyPopup, setHistoryPopup, historyRowData, historyColDef, historyLoader])
}